import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import {EXPLORER_PARKING_STATUS_COLOURS} from 'Utils/constants';
import PropTypes from 'prop-types';

const ParkingStatusLabel = ({status, parkingStatusMapping}) => {
    const parkingStatus = (parkingStatusMapping && parkingStatusMapping[status]) || status;
    const ColorButton = withStyles(() => ({
        root: {
            pointerEvents: 'none',
            color: 'white',
            padding: '0px 8px',
            fontSize: 11,
            minWidth: 'unset',
            boxShadow: 'unset',
            backgroundColor: EXPLORER_PARKING_STATUS_COLOURS[status],
            '&:hover': {
                backgroundColor: EXPLORER_PARKING_STATUS_COLOURS[status],
            },
        },
    }))(Button);
    return (
        <ColorButton
            disableFocusRipple
            disableRipple
            variant="contained"
            className="parking-status-button"
            aria-label="parking-status"
        >
            {parkingStatus.toUpperCase()}
        </ColorButton>
    );
};

ParkingStatusLabel.propTypes = {
    status: PropTypes.oneOf(Object.keys(EXPLORER_PARKING_STATUS_COLOURS)).isRequired,
    parkingStatusMapping: PropTypes.object,
};

export default ParkingStatusLabel;
